export const ORDER_TYPES = {
  UNDER_CONSTRUCTION: "UnderConstruction",
  SERVICE: "Service",
  UNDER_WARRANTY: "UnderWarranty",
};

export const ORDER_TYPES_OPTIONS = [
  {
    label: "Service",
    value: ORDER_TYPES.SERVICE,
  },
  {
    label: "Under Construction",
    value: ORDER_TYPES.UNDER_CONSTRUCTION,
  },
  {
    label: "Under Warranty",
    value: ORDER_TYPES.UNDER_WARRANTY,
  },
];
